const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
const fullYear = new Date().getFullYear();
const years = <any> [];
for (let i = 0; i< 10; i++){
    years.push((fullYear - i));
}
export default {months,years}